import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import type { FunctionComponent } from 'react';

const LoaderContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: '0.3rem',
    width: '100%',
});

const shimmer = keyframes`
    0% {
        background-position: -62.5rem 0;
    }
    100% {
        background-position: 62.5rem 0;
    }
`;

const LoaderLine = styled.div`
    height: 0.7rem;
    border-radius: 0.25rem;
    background: linear-gradient(90deg, #f6f6f7 0%, #f1f1f0 46.72%, #f6f6f7 100%);
    background-size: 125rem 100%;
    animation: ${shimmer} 1.5s linear infinite;
`;

const ShortLoaderLine = styled(LoaderLine)({
    width: '50%',
});

export const Loader: FunctionComponent = () => {
    return (
        <LoaderContainer>
            <LoaderLine />
            <LoaderLine />
            <ShortLoaderLine />
        </LoaderContainer>
    );
};
